<template>
    <div
        class="fancy-wrap"
        :data-fancybox="name"
        :data-src="src"
    >
        <slot></slot>
    </div>
</template>

<script>
import { Fancybox } from "@fancyapps/ui/dist/fancybox.esm.js";

export default {
    name: 'Fancybox',
    props: {
        name: {
            type: String,
            default: '',
        },
        src: {
            type: String,
            default: '',
        },
        options: {
            type: Object,
            default: () => {}
        }
    },
    setup: (props, ctx) => {

        return {

        }
    },
}
</script>

<style lang="scss" scoped>
  @import "@fancyapps/ui/dist/fancybox.css";
</style>